<template>
  <form-section
    id="supplier_rights_and_obligations"
    :headline="this.$t('form.supplier_rights_and_obligations.legend')"
    v-if="!isDistributor"
  >
    <textfield
      id="compensation"
      :label="$t('form.supplier_rights_and_obligations.compensationPercentage.label')"
      :placeholder="$t('form.supplier_rights_and_obligations.compensationPercentage.placeholder')"
      v-model="supplierRightsAndObligations.compensationPercentage"
      append-text="%"
      isRequired
    />
  </form-section>
</template>

<script>
import Textfield from "@/shared/components/Textfield.vue";
import FormSection from "@/shared/components/FormSection.vue";
export default {
  components: {
    Textfield,
    FormSection
  },
  data() {
    return {
      supplierRightsAndObligations: {
        compensationPercentage: ""
      }
    };
  },
  computed: {
    isDistributor() {
      return this.$store.getters.isDistributorType;
    }
  },
  watch: {
    supplierRightsAndObligations: {
      handler() {
        this.$store.commit(
          "updateSupplierRightsAndObligations",
          this.supplierRightsAndObligations
        );
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/SupplierRightsAndObligationsInput.vue